

















import {Component, Prop, Vue} from 'vue-property-decorator'
import DataSpecsFormItems from "@/component/Thing/data-specs-form-items.vue";
import {ParamStdProxy} from "@/module/thing/ParamProxy"

@Component({
  components: {
    DataSpecsFormItems
  },
})
export default class ParamStdProxyFormItems extends Vue {
  @Prop() private paramProxy!: ParamStdProxy
  @Prop() private disabledIdentifier!: boolean
}
